import type {BossKillsDuck} from '..';

export function getkillDataByCharacterIdForEncounter(
	state: BossKillsDuck.IState,
	encounterId: string
) {
	return state.byEncounterId.get(encounterId);
}
